// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/loadingDNA.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingIcon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.backdrop {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  z-index:1000;
  backdrop-filter: blur(5px);
  backdrop-filter: grayscale(100%);
  
}
.Text {
  font-family: 'IBM Plex Sans', sans-serif !important;
  font-weight: 100 !important;
  
}

.p-progressbar .p-progressbar-value {
  border: 0 none;
  margin: 0;
  background: #000000;
}

.Loading {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index:2005;
}
.LoadingWrap {
  
  position: relative;
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);
  width: 610px;
  height: 210px;
  z-index:2005;
}

.LoadingBox  {
  background: #ffffff;
  margin: 5px 5px 5px 5px;
  padding: 20px;
  width: 600px;
  height: 200px;
  z-index:2005;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/Loading/Loading.css"],"names":[],"mappings":"AAAA;EACE,yDAAuD;AACzD;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,0CAA0C;EAC1C,YAAY;EAEZ,0BAA0B;EAC1B,gCAAgC;;AAElC;AACA;EACE,mDAAmD;EACnD,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;AACd","sourcesContent":[".loadingIcon {\n  background-image: url('../../../assets/loadingDNA.svg');\n}\n.backdrop {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index:1000;\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n  backdrop-filter: grayscale(100%);\n  \n}\n.Text {\n  font-family: 'IBM Plex Sans', sans-serif !important;\n  font-weight: 100 !important;\n  \n}\n\n.p-progressbar .p-progressbar-value {\n  border: 0 none;\n  margin: 0;\n  background: #000000;\n}\n\n.Loading {\n  min-height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index:2005;\n}\n.LoadingWrap {\n  \n  position: relative;\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n  width: 610px;\n  height: 210px;\n  z-index:2005;\n}\n\n.LoadingBox  {\n  background: #ffffff;\n  margin: 5px 5px 5px 5px;\n  padding: 20px;\n  width: 600px;\n  height: 200px;\n  z-index:2005;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
